/**
 * Normalización y validación de email compartida entre apps (negocio, portal,
 * rider). Refleja las reglas que aplica GoTrue en `auth/v1/signup`: ASCII
 * puro, local part con el set de símbolos permitido y dominio con labels
 * estilo hostname (sin `_`, sin `-` al inicio/fin de label, sin `..`).
 */

// Caracteres invisibles que llegan por autofill/copy-paste y que GoTrue
// rechaza con `validation_failed`: soft hyphen, ZWSP/ZWNJ/ZWJ, marcas RTL,
// controles bidi, word joiner y BOM.
const INVISIBLE_CHARS = /[\u00AD\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\uFEFF]/g;

export const EMAIL_REGEX =
  /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;

/** Normaliza un correo para enviar al backend: quita invisibles, trim, lowercase. */
export function normalizeEmail(email: string): string {
  return email.replace(INVISIBLE_CHARS, '').trim().toLowerCase();
}

/**
 * Válido según lo que GoTrue acepta en signup. Normaliza antes de chequear,
 * así un ZWSP invisible no hace fallar un email correcto.
 */
export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(normalizeEmail(email));
}
